import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { CreditCard, Wallet, Shield, Lock } from 'lucide-react';

const PaymentMethods = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="pt-24 px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Payment Methods</h1>
          <p className="text-gray-400 text-lg mb-12">We support multiple secure payment options</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Stripe/Credit Card */}
            <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10 hover:border-purple-500/50 transition-all">
              <CardContent className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-purple-600/20 rounded-xl flex items-center justify-center mr-4">
                    <CreditCard className="text-purple-400" size={32} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Credit/Debit Cards</h3>
                    <p className="text-gray-400">Powered by Stripe</p>
                  </div>
                </div>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-2">✓</span>
                    Visa, Mastercard, American Express
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-2">✓</span>
                    Instant payment processing
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-2">✓</span>
                    3D Secure authentication
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-2">✓</span>
                    Bank-level encryption
                  </li>
                </ul>
              </CardContent>
            </Card>

            {/* PayPal */}
            <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10 hover:border-purple-500/50 transition-all">
              <CardContent className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-600/20 rounded-xl flex items-center justify-center mr-4">
                    <Wallet className="text-blue-400" size={32} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">PayPal</h3>
                    <p className="text-gray-400">Secure online payments</p>
                  </div>
                </div>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-center">
                    <span className="text-blue-400 mr-2">✓</span>
                    PayPal balance or linked cards
                  </li>
                  <li className="flex items-center">
                    <span className="text-blue-400 mr-2">✓</span>
                    Buyer protection included
                  </li>
                  <li className="flex items-center">
                    <span className="text-blue-400 mr-2">✓</span>
                    No card details shared
                  </li>
                  <li className="flex items-center">
                    <span className="text-blue-400 mr-2">✓</span>
                    Fast checkout process
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>

          {/* Security Features */}
          <Card className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 border-white/10">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                <Shield className="mr-3 text-green-400" size={28} />
                Security & Protection
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <div className="flex items-center mb-3">
                    <Lock className="text-purple-400 mr-2" size={20} />
                    <h4 className="text-white font-semibold">SSL Encrypted</h4>
                  </div>
                  <p className="text-gray-400 text-sm">
                    All payment data is encrypted with industry-standard 256-bit SSL encryption.
                  </p>
                </div>
                <div>
                  <div className="flex items-center mb-3">
                    <Shield className="text-purple-400 mr-2" size={20} />
                    <h4 className="text-white font-semibold">PCI Compliant</h4>
                  </div>
                  <p className="text-gray-400 text-sm">
                    We maintain PCI DSS compliance for secure card data handling.
                  </p>
                </div>
                <div>
                  <div className="flex items-center mb-3">
                    <CreditCard className="text-purple-400 mr-2" size={20} />
                    <h4 className="text-white font-semibold">No Storage</h4>
                  </div>
                  <p className="text-gray-400 text-sm">
                    Card details are never stored on our servers - processed directly by payment providers.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentMethods;